import axios from 'axios';
import qs from 'qs';
import router from '@/router';

	// 获取外部json文件
	let hospitalConfig,hospitalCode,hospitalVersion,UboxCallFlag,baseUrl,hospitalName,smsFlag,GXwsUrl,GXcallflag,emrUrl1,registerUrl,wxQrflag,showGetNewPhone;
	(async()=>{
		let data=await axios({
			url:location.origin+'/hospital.json',
			method:'get'
		})
		hospitalConfig=data.data;
		hospitalCode=hospitalConfig.hospitalCode;///线上演示版：YS_HM4，通用:general，遂昌：ZJ_SC1 尤溪：FJ_YX1 天等外网：GX_TD1，三明第一：FJ_SM1,章丘：SD_ZQ1,大田：FJ_DT1，泰宁：FJ_TN1，迁安：HE_QA1，永安：FJ_SM2，宁化：FJ_NH1
		hospitalVersion='4.9.7.6';
		UboxCallFlag=hospitalConfig.UboxCallFlag;//判断医院有无呼叫
		hospitalName=hospitalConfig.hospitalName;
		smsFlag=hospitalConfig.smsFlag;//判断医院有无呼叫
		baseUrl = '';
		GXwsUrl=hospitalConfig.GXwsUrl;//冠讯wsurl
		GXcallflag=hospitalConfig.GXcallflag;//判断医院有无冠讯呼叫
		emrUrl1=hospitalConfig.emrUrl1;//判断医院是否有第二个电子病历及第二个电子病历名称
		registerUrl = hospitalConfig.registerUrl;//判断医院是否有预约挂号链接
		wxQrflag=hospitalConfig.wxQrflag;//判断医院是否需要小程序二维码
		showGetNewPhone=hospitalConfig.showGetNewPhone;//判断医院是否显示获取最新电话按钮

		switch(hospitalCode){
			case 'YS_HM4':
				// baseUrl = 'http://192.168.50.178:8172';
				// baseUrl = window.location.origin+':19988';
				baseUrl = 'https://hm4.healthydao.com:19988';
				// baseUrl = 'http://192.168.50.200:8172';
				break;
			// case 'GX-TD1'://天等外网
			// 	baseUrl = 'http://'+window.location.hostname+':18172';//单独在39服务器上放了一版，外网访问了
			// 	break;
			case 'GX_TD1':
				if(window.location.hostname == "39.98.49.111" || window.location.hostname == "tiandeng.healthydao.com"){
					baseUrl = 'http://'+window.location.hostname+':18172';
				}else{
					baseUrl = 'http://'+window.location.hostname+':8172';
				}
			break;
			case 'SD_TA2'://泰安市中心医院
				if(window.location.hostname == "223.99.8.208"){
					baseUrl = 'http://'+window.location.hostname+':18172';
				}else{
					baseUrl = 'http://'+window.location.hostname+':8172';
				}
			break;
			case 'FJ_SM1'://三明第一
				if(window.location.hostname == "jbglxt.smdyyy.cn"){
					baseUrl = 'https://'+window.location.hostname+':38172';//单独在前置机上放了一版，外网访问了
				}else{
					baseUrl = 'http://'+window.location.hostname+':8172';
				}
				break;
			case 'HE_QA1':
				baseUrl = 'http://'+window.location.hostname+':18172';
				break;
			case 'SD_LY1'://临沂
				if(window.location.hostname == "221.2.94.162"){
					baseUrl = 'http://'+window.location.hostname+':18172';
				}else{
					baseUrl = 'http://'+window.location.hostname+':8172';
				}
			break;
			default:
				baseUrl = 'http://'+window.location.hostname+':8172';
				// baseUrl = 'https://hm4.healthydao.com:19988';

				break;
		}
		console.log(hospitalConfig,'--------config');
	})()
function result(res) {
	if (res.status == 200) {return res.data;}
	return { code: res.status, msg: res.statusText};
}
function getUser() {
	let user = localStorage.getItem('user');
	if (user) {
		return JSON.parse(user).data;
	}
	return {};
}

export default class api {
	// 是否显示获取最新电话按钮
	static async getShowGetNewPhone() {
		return showGetNewPhone;
	}
	// 是否开启微信二维码
	static async getWeQrflag() {
		return wxQrflag;
	}
	/**
	 * 获取当前医院code
	 */
	static async getHospitalCode() {
		return hospitalCode;
	}
	/**
	 * 获取当前医院冠讯呼叫url
	 */
	static async getGXwsUrl() {
		return GXwsUrl;
	}
	/**
	 * 判断医院是否有冠讯呼叫
	 */
	static async getGXcallFlag() {
		return GXcallflag;
	}
	// 获取url
	static async getHospitalBaseUrl() {
		return baseUrl;
	}
	/**
	 * 获取当前医院名
	 */
	static async getHospitalName() {
		return hospitalName;
	}
	/**
	 * 获取当前医院版本号
	 */
	static async getHospitalVersion() {
		return hospitalVersion;
	}
	/**
	 * 获取有无呼叫
	 */
	static async getUboxCallFlag() {
		return UboxCallFlag;
	}
	/**
	 * 获取有无短信
	 */
	static async getSmsFlag() {
		return smsFlag;
	}
	// 田东 获取出院/门诊医嘱接口
	static async getMedicalOrders(opt) {
		let user = getUser();
		let res = await axios({
			url: `http://192.168.1.115:8096/medical_orders`,
			method: 'post',
			headers : {'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});		
		return result(res);
	}
	// 修改短信模板
	static async updateSmsTemplate(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/sms/updateSmsTemplate`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 分页查询短信模板列表(下拉框仅传templateType即可)
	static async queryTemplateList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/sms/queryTemplateList`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 删除短信模板
		static async deleteSmsTemplate(opt) {
			let user = getUser();
			let res = await axios({
				url: `${baseUrl}/template/sms/deleteSmsTemplate`,
				method: 'post',
				headers : {'token': user.token},
				data: qs.stringify(opt)
			});		
			return result(res);
		}
	// 新增短信模板
	static async addSmsTemplate(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/sms/addSmsTemplate`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 获取患者所有的管理日志
	static async getListPatientTreeTimeline(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/listPatientTreeTimeline`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 问卷统计 问卷下拉框
	static async getComboboxQuestionnaire(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questiondict/getComboboxQuestionnaire`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 复诊工作量统计
	static async getReturnReportList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/returnVisit/listFollowupReturnVisitDoctorReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}

	// 获取uniapp推送列表
	static async getListUniappPush(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/uniapp/listUniappPush`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 院中 找患者删除
	static async inhospitalRemove(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/inhospital/remove`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 出院门诊排期 找患者删除
	static async outhospitalRemove(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/outhospital/remove`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 推送单条随访记录
	static async pushFollowupData(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/pushFollowupData`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 检验患者信息
	static async checkAddPatientParam(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/checkAddPatientParam`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 手动添加患者
	static async addPatient(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/addPatient`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 手动添加就诊记录
	static async addRecord(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/medicalRecord/addRecord`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	
	// 获取单条排期模板
	static async getQueryByTemplateScheduleId(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/queryByTemplateScheduleId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}

	// 删除年度报告
	static async deleteAnnualReport(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/annualReport/deleteAnnualReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	//获取年度报告
	static async getAnnualReport(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/annualReport/getAnnualReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 修改满意度
	static async checkAddOrModify(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/serviceSatisfaction/checkAddOrModify`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 查询满意度
	static async getServiceSatisfaction(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/serviceSatisfaction/getServiceSatisfaction`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 修改慢病费用
	static async checkAddOrModifyFee(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/ncdFee/checkAddOrModify`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	// 查询糖尿病慢病费用
	static async getNcdDM(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/ncdFee/getNcdDM`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 查询高血压慢病费用
	static async getNcdHBP(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/ncdFee/getNcdHBP`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 获取年度报告列表
	static async getAnnualReportList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/annualReport/getAnnualReportList`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 下载
	static downloadReport(opt) {
		let user = getUser();
		return `${baseUrl}/annualReport/download?${qs.stringify(opt)}&token=${user.token}`;
	}
	/**
	 * 获取有无第二个电子病历 及病历名称
	 */
	static async getemrUrl1() {
		return emrUrl1;
	}
	// 申请开具六大处方
	static async applyPrescription(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/prescription/applyPre`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 处方宣教
	static async eduPrescription(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/prescription/eduPre`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 结束院中管理
	static async finishInhospital(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/inhospital/finish`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 检验是否能查看处方
	static async checkPreVisibleTypes(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/inhospitalPlus/checkPreVisibleTypes`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 推送问卷绑定 评估
	static async updatePushQ(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questionresult/updatePushQ`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 评估内查看历史问卷
	static async getEvalHistoryQ(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/pad/questionnaire/listUniappQuestionnaire`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	
	// 获取二维码对应url
	static async getQrUrl(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/qr/getQrUrl`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 推送处方
	static async pushPrescription(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/prescription/pushPrescription`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 获取评估推送状态
	static async getEvalPushState(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/eval/push/getEvalPushState`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}
	// 推送评估
	static async pushEval(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/eval/push/pushEval`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});		
		return result(res);
	}


	/**
	 * 获取有无挂号链接
	 */
	static async getRegisterUrl() {
		return registerUrl;
	}
	/**
	 * 用户登录
	 */
	static async login(opt) {
		let res = await axios.post(`${baseUrl}/login`, qs.stringify(opt));
		return result(res);
	}

	/**
	 * sso单点登录
	 */
	static async ssoLogin(opt) {
		let res = await axios.post(`${baseUrl}/ssoLogin`, qs.stringify(opt));
		return result(res);
	}
	// 健商统计
	static async listHealthQuotientReport(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/eval/listHealthQuotientReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 标记电话 有效无效
	static async insertValid(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/insertValid`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 问卷看板列表
	static async getQuestionnaireFollowup(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/questiondictReport/getQuestionnaireFollowup`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 新增关于
	static async getMyData(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysRule/getMyData`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 账号管理-部分科室
	static async getListComboboxDep(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/department/listComboboxDep`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 查询科室
	static async getOrgDept(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysOrg/orgDept`,
			method: 'get',
			headers : {'token': user.token},
			params: opt,
		});
		return result(res);
	}
		// 补抓记录
		static async getLogList(opt) {
			let user = getUser();
			let res = await axios({
				url: `${baseUrl}/interfaceLog/getLogList`,
				method: 'get',
				headers : {'token': user.token},
				params: opt,
			});
			return result(res);
		}
		// 补抓患者

	static async getSyncData(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/interfaceLog/syncData`,
			method: 'get',
			headers : {'token': user.token},
			params: opt,
		});
		return result(res);
	}
	/**
	 * 批量修改科室管理状态
	 */
	static async updateStateList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/department/updateStateList`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 获取最新同步时间
	static async getInterfaceSyncDate(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/interfaceLog/getInterfaceSyncDate`,
			method: 'get',
			headers : {'token': user.token},
			params: opt,
		});
		return result(res);
	}
	/**
	 * 复诊出院时间批量删除
	 */
	static async delAppointmentReturnByOutDate(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/delAppointmentReturnByOutDate`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 复诊预约时间批量删除
	 */
	static async delAppointmentReturnByAppDate(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/delAppointmentReturnByAppDate`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 随访批量删除
	 */
	static async delFollowup(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/delFollowup`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	//获取错误信息列表(找患者住院/出院/门诊未抓取)
	static async getListErrorNewMsg(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/log/listErrorNewMsg`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 大屏配置
	static async getDashboardConfigList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/dashboard/getDashboardConfList`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	// 获取大屏配置单条
	static async getDashboardConfigById(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/dashboard/getDashboardConfById`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 修改大屏配置
	static async updateDashboardConfig(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/dashboard/updateDashboardConf`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 删除大屏配置单条
	static async delDashboardConfigById(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/dashboard/delDashboardConfById`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 新增大屏配置单条
	static async addDashboardConfig(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/dashboard/addDashboardConf`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 获取授权时间+版本号
	static async checkAuthorize(){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysRule/checkAuthorize`,
			method: 'post',
			headers : {'token': user.token},
		});
		return result(res);
	}

	// 数据管理-批量修改
	// 院中管理
	static async inhospitalModifyStatusInBatch(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/inhospital/modifyStatusInBatch`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 出院排期管理
	static async outhospitalModifyStatusInBatch(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/outhospital/modifyStatusInBatch`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 门诊排期管理
	static async outpatientModifyStatusInBatch(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/outpatient/modifyStatusInBatch`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 随访管理-单次
	static async followupModifyStatusInBatch(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/modifyStatusInBatch`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 随访管理-全部
	static async followupModifyStatusInBatchAll(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/modifyStatusInBatchAll`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 大屏
	// 疾病管理人次和慢病管理人数
	static async getDiseaseAndChronicCount(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/dashboard/getDiseaseAndChronicCount`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 获取六大处方统计
	static async getInHospitalTal(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/dashboard/getInHospitalTal`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 主要慢病科室再住院人次
	static async getMainCDSDepAgainAmount(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/dashboard/getMainCDSDepAgainAmount`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 主要慢病评估及处方人次
	static async getMainCDSEvalAndRxAmount(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/dashboard/getMainCDSEvalAndRxAmount`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 获取复诊数据统计
	static async getReturnVisit(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/dashboard/getReturnVisit`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 获取工作台今日工作数据
	 */
	static async getWorkbenchScheduling(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/workbench/getWorkbenchSchedulingDetail`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取工作台日历数据
	 */
	static async getWorkbenchCalendar(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/workbench/getWorkbenchCalendarDetail`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取工作台今日所有复诊数据
	 */
	static async getWorkbenchToday(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/workbench/getWorkbenchTodayDetail`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取当前用户所有消息
	 */
	static async getWorkbenchMessage(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/message/listMessageByUserId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 获取问卷所有数据
	static async getQuestionresultList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questionresult/list/all`,
			method: 'get',
			headers : {'token': user.token},
			params: opt,
		});
		return result(res);
	}

	// 延续性护理服务列表查询
	static async getContinuityCareList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/continuityCare/listContinuityCare`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 根据id查询延续性护理服务记录
	static async getContinuityCareById(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/continuityCare/getContinuityCareById`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 根据就诊id查询延续性护理服务记录
	static async getContinuityCareByRecordId(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/continuityCare/listContinuityCareByRecordId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 新增延续性护理服务记录
	static async addContinuityCare(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/continuityCare/addContinuityCare`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 删除延续性护理服务记录
	static async delContinuityCare(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/continuityCare/delContinuityCare`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 修改延续性护理服务记录
	static async updateContinuityCare(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/continuityCare/updateContinuityCare`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 获取一周图表数据
	 */
	static async getWorkbenchWeek(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/workbench/getWorkbenchWeekDetail`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取患者分组信息列表
	 */
	static async getPatientGroupList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/listPatientGrouping`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取单个患者分组信息
	 */
	static async getPatientGroupById(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/detail/${id}`,
			method: 'get',
			headers : {'token': user.token}
		});
		return result(res);
	}

	/**
	 * 添加患者分组信息
	 */
	static async addPatientGroup(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/insertPatientGroupingByGroupingId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 修改患者分组信息
	 */
	static async editPatientGroup(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/updatePatientGroupingByGroupingId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 删除患者分组信息
	 */
	static async delPatientGroup(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/deletePatientGroupingByGroupingIds`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 更新患者分组信息
	 */
	static async syncPatientGroup(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/syncPatientGroupingByGroupingId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 患者信息列表 (患者分组)
	 */
	static async getGroupingPatientList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/listGroupingPatient`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 修改患者所属分组
	 */
	static async changePatientGroup(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/updatePatientToGrouping`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 删除患者分组里的患者
	 */
	static async delPatientFromGroup(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/delPatientToGrouping`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取患者信息列表
	 */
	static async getPatientList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/listPatient`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取患者信息详情
	 */
	static async getPatient(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/getPatientDetail`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}


	/**
	 * 获取疾病标签列表 (患者列表用)
	 */
	static async getPatientFilterTag() {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/listTag`,
			method: 'post',
			headers : {'token': user.token}
		});
		return result(res);
	}

	/**
	 * 修改患者信息（患者星标修改也用此方法）
	 */
	static async editPatient(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/updatePatientDetailByPatientId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 修改患者标签
	 */
	static async updatePatientTag(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/updatePatientTag	`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 添加患者到分组
	 */
	static async addPatientToGroup(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/addPatientToGrouping`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 批量加星标
	 */
	static async addPatientToStar(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/updateStarList`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取疾病标签列表 (患者列表用)
	 */
	static async getPatientAllTag() {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/listTag`,
			method: 'post',
			headers : {'token': user.token}
		});
		return result(res);
	}

	/**
	 * 获取患者所有的管理日志
	 */
	static async getPatientLogList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/listPatientTreeTimeline`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}


	/**
	 * 获取患者亲属列表
	 */
	static async getRelativeList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/listPatientRelatives`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 添加患者亲属信息
	 */
	static async addRelative(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/insertPatientRelatives`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 修改患者亲属信息
	 */
	static async editRelative(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/updatePatientRelativesByPatientRelativesId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取无身份证患者列表
	 */
	static async getNoIdentityList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/nocard/list`,
			method: 'get',
			headers : {'token': user.token},
			// data: qs.stringify(opt)
			params: opt,
		});
		return result(res);
	}

	/**
	 * 补充身份证
	 */
	static async editNoIdentityCardNum(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/supplement/cardNum`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 合并患者账号
	 */
	static async mergeNoIdentityCardNum(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/merge/cardNum`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}


	/**
	 * 获取院中患者列表
	 * @recordState 管理状态(0待分配，1管理中，2已结束，3未管理，4勿访)
	 */
	static async getHospitalPatientList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/inhospital/listInhospital`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 院中分配疾病管理师(单条，批量)，勿访（单条，批量）
	 */
	static async updateHospitalPatientState(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/inhospital/updateInhospitalDetail`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 院中分配疾病管理师回退
	 */
	static async rollbackrecordState(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/inhospital/back`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}


	/**
	 * 获取出院（排期）信息列表
	 */
	static async getScheduleList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/outhospital/listOuthospital`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 出院（排期）勿访
	 */
	static async updateScheduleState(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/outhospital/updateOuthospitalByDetialId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 20210827
	 * 出院（排期）回退
	 */
	static async rollbackScheduleState(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/outhospital/updateOuthospitalStatusByDetialId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取患者沟通记录信息列表
	 */
	static async getCommunicationList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/message/listCommunicationRecordByPatientId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取院中沟通记录信息列表
	 */
	static async getCommunicationListByRecordId(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/message/listCommunicationRecordByRecordId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 院中沟通记录（对话）信息列表
	 */
	static async listCommunicationRecord(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/message/listCommunicationRecord`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}


	/**
	 * pc院中发消息
	 */
	static async addCommunication(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/message/sendCommunicationRecord`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取患者所有的备忘录
	 */
	static async getNoteList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/listPatienttNotes`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 添加患者所有的备忘录
	 */
	static async addNote(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/insertPatienttNotes`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 删除备忘录
	 * @param {integer} patientNoteId 备忘录id
	 */
	static async delNoteList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/delPatienttNotes`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 获取随访记录的列表
	 */
	static async getFollowList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/listFollowupByObject`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 获取错误信息列表
	 */
	static async getErrorMsg(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/log/listErrorMsg`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	//短信发送记录
	static async getSmsSendList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/message/getSmsSendList`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 短信充值记录
	static async getSmsCountList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/message/getSBKSmsCount`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	/**
	 * 根据recordId获取随访记录的列表
	 */
	static async getFollowListByRecordId(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/listFollowupByRecordId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 根据 Date 获取随访记录的列表
	 */
	static async getFollowListByDate(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/listFollowupByDate`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取单条随访记录
	 */
	static async getFollow(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/getFollowupById`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取从列表修改随访记录详情 (患者 - 就诊记录 - 排期管理)
	 */
	static async getFollowByFollowupId(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/getFollowupByFollowupId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 20211129
	 * 随访回退
	 */
	static async rollbackFollowState(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/updateFollowupStatusByFollowupId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 新建排期
	 */
	static async addFollow(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/addFollowup`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 修改单条随访记录
	 */
	static async editFollow(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/updateFollowupById`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 从列表修改随访记录 (患者 - 就诊记录 - 排期管理)
	 */
	static async editFollowByFollowupId(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/updateFollowupByFollowupId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 从列表删除随访记录
	 */
	static async delFollow(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/delFollowupByFollowupId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 终止随访
	 */
	static async stopFollow(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/stopFollowupById`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 获取签约患者信息列表
	 */
	static async getContractList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sign/list`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt),
		});
		return result(res);
	}

	/**
	 * 签约-根据id查询数据
	 */
	static async getContractById(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sign/${opt.id}`,
			method: 'get',
			headers : {'token': user.token},
			params: opt,
		});
		return result(res);
	}

	/**
	 * 客户签约-签约
	 */
	static async setContractSigned(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sign/dosign`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 客户签约-回退
	 */
	static async setContractBack(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sign/back`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 客户签约-无意向
	 */
	static async setContractEnd(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sign/nointention`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取历史处方
	 */
	static async getPrescriptionList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/prescription/listPrescription`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 根据就诊记录id获取历史处方
	 */
	static async getPrescriptionListByRecordId(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/prescription/listPrescriptionByRecordId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 根据就诊记录id获取历史处方和最新评估结果
	 */
	static async queryPrecription(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/prescription/queryPrecription`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 新增发布/待发布处方
	 */
	static async addPrescription(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/prescription/insertPrescription`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	/**
	 * 删除处方
	 */
	static async delPrescription(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/prescription/delPrescription`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 复诊记录的列表
	 */
	static async getSubsequentVisitList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/listAppointmentReturnVisitByObject`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 患者单次就诊记录复诊记录的列表
	 */
	static async getSubsequentVisitListByRecordId(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/listAppointmentReturnVisitByRecordId`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 新增预约复诊
	 */
	static async addSubsequentVisit(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/insertAppointmentReturnVisit`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 *  修改复诊记录
	 */
	static async editSubsequentVisit(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/updateAppointmentReturnVisitById`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 重约
	static async recontractSubsequentVisit(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/recontractReturnVisitById`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * （取消预约复诊）删除复诊记录
	 */
	static async delSubsequentVisit(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/delAppointmentReturnVisitByid`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 更改复诊提醒方式
	static async editReVisitManual(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/followup/updateReturnVisitManualStateById`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	//院中管理统计
	static async getInHospitalManagerReport(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/inHospital/listInHospitalManagerReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 评估统计
	static async getEvaluatorsReportList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/inHospital/listEvaluatorsReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 处方统计
	static async getPrescriptionReportList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/inHospital/listPrescriptionReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 住院工作量统计
	 */
	static async getWorkloadScheduleList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/outHospitalWorkload/listReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 住院医生工作量统计
	 */
	static async getWorkloadDocList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/outHospitalWorkload/listDocReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 出院随访统计
	 */
	static async getWorkloadFollowList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/outHospitalfollowup/listReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 出院疾病管理师随访统计
	 */
	static async getWorkloadDMList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/outHospitalfollowup/listDiseaseManagerReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}


	/**
	 * 门诊医生工作量统计
	 */
	static async getOutpatientScheduleList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/outPatientWorkload/listReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 门诊工作量统计
	 */
	static async getOutpatientDocList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/outPatientWorkload/listDocReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 门诊随访统计
	 */
	static async getOutpatientFollowList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/outPatientfollowup/listReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 门诊疾病管理师随访统计
	 */
	static async getOutpatientDMList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/outPatientfollowup/listDiseaseManagerReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取科室信息列表
	 */
	static async getDeptList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/department/listDepartment`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 获取单条科室
	 */
	static async getDept(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/department/getOneDepartment`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取科室下拉框
	 */
	static async getDeptDropdown(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/department/listComboboxDepartment`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取用户下拉框（疾病管理师）
	 */
	static async getComboboxUserList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/user/getComboboxUserList`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}	
	
	/**
	 * 获取患者电话本下拉框
	 */
	static async getPhonebookList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/call/phonebook/getPhonebookList`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}	
		
	/**
	 * 添加单条科室
	 */
	static async addDept(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/department/insertDepartment`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 修改单条科室
	 */
	static async editDept(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/department/updateDepartment`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 科室管理 - 删除
	 */
	static async delDept(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/department/delete`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 导入科室
	 */
	static async importDept(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/department/excel/import`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'multipart/form-data'},
			data: opt
		});
		return result(res);
	}



	/**
	 * 获取标签列表
	 */
	static async getTagList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/tag/list`,
			method: 'get',
			headers : {'token': user.token},
			params: opt,
		});
		return result(res);
	}

	/**
	 * 获取单条标签
	 */
	static async getTag(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/tag/${id}`,
			method: 'get',
			headers : {'token': user.token},
		});
		return result(res);
	}

	/**
	 * 添加标签
	 */
	static async addTag(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/tag/add`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 修改标签
	 */
	static async editTag(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/tag/update`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取ICD列表
	 */
	static async getIdcList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/tag/icd/page`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取患者的就诊记录
	 */
	static async getFollowUpList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/medicalRecord/listMedicalRecord`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取就诊记录详情
	 */
	static async getFollowUp(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/medicalRecord/getMedicalRecordDetailById`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 患者的专项管理 - 分页
	 */
	static async getPatientSpecialList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patientSpecificManager/list`,
			method: 'get',
			headers : {'token': user.token},
			params: opt,
		});
		return result(res);
	}

	/**
	 * 患者的专项管理 - 单条数据
	 */
	static async getPatientSpecial(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patientSpecificManager/${id}`,
			method: 'get',
			headers: {'token': user.token}
		});
		return result(res);
	}

	/**
	 * 患者的专项管理 - 管理计划提交
	 */
	static async submitPatientSpecialPlan(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patientSpecificManager/submit`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json',},
			data: opt
		});
		return result(res);
	}

	/**
	 * 患者的专项管理 - 管理计划提交 修改
	 */
	static async editPatientSpecialPlan(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patientSpecificManager/update`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json',},
			data: opt
		});
		return result(res);
	}

	/**
	 * 专项管理配置类型
	 */
	static async getPatientSpecialType(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patientSpecificManager/type`,
			method: 'get',
			headers : {'token': user.token},
			params: opt,
		});
		return result(res);
	}

	/**
	 * 患者的专项管理 - 添加
	 */
	static async addPatientSpecial(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patientSpecificManager/add	`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json',},
			data: opt
		});
		return result(res);
	}

	/**
	 * 患者的专项管理 - 修改
	 */
	static async editPatientSpecial(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patientSpecificManager/update`,
			method: 'post',
			headers : {
				'token': user.token,
				'Content-Type': 'application/json',
			},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 患者的专项管理 - 删除
	 */
	static async delPatientSpecial(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patientSpecificManager/del/${id}`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify({id})
		});
		return result(res);
	}

	/**
	 * 六方成评估 - 所有评估类型
	 */
	static async getCustomerEvalType() {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/customerEval/types`,
			method: 'post',
			headers : {'token': user.token},
		});
		return result(res);
	}

	/**
	 * 六方成评估 - 用户评估数据（左边栏）
	 */
	static async getCustomerAllEval(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/customerEval/all/latest/type`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 六方成评估 - 评估列表
	 */
	static async getCustomerEvalList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/customerEval/list`,
			method: 'get',
			headers : {'token': user.token},
			// data: qs.stringify(opt)
			params: opt,
		});
		return result(res);
	}

	/**
	 * 六方成评估 - 单项评估数据
	 */
	static async getCustomerEval(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/customerEval/${id}`,
			method: 'get',
			headers : {'token': user.token},
			// data: qs.stringify(opt),
			params: {id}
		});
		return result(res);
	}

	/**
	 * 六方成评估 - 添加
	 */
	static async addCustomerEval(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/customerEval/add`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 六方成评估 - 删除
	 */
	static async delCustomerEval(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/customerEval/del/${id}`,
			method: 'post',
			headers : {'token': user.token},
			data: {id}
		});
		return result(res);
	}


	/**
	 * 六方成评估 - 问卷内容
	 */
	static async getQuest(opt) {
		let user = getUser();
		let res = await axios({
			// url: `http://47.92.130.45:9001/tduck-api/user/form/details/${opt.key}`,
			url: `${baseUrl}/questiondict/${opt.id}`,
			method: 'get',
			headers : {'token': opt.token || user.token},
			// data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 六方成评估 - 问卷结果
	 */
	static async getQuestResult(opt) {
		let user = getUser();
		let res = await axios({
			// url: `http://47.92.130.45:9001/tduck-api/user/form/fields/${opt.key}`,
			url: `${baseUrl}/questionresult/${opt.id}`,
			method: 'get',
			headers : {'token': opt.token || user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			// data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 六方成评估 - 问卷结果保存
	 */
	static async saveQuestResult(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/customerEval/add/questionnaireResult`,
			method: 'post',
			headers : {'token':opt.token || user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 六方成评估 - 评估
	 */
	static async assessCustomerEval(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/customerEval/assess`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 知识库 - 目录接口
	 */
	static async getKnowledgeList() {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/knowledgebase/listKnowledge`,
			method: 'post',
			headers : {'token': user.token},
			// data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 知识库 - 查询单个文档接口
	 */
	static async getKnowledge(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/knowledgebase/getKnowledgeContext`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 知识库 - 搜索接口
	 */
	static async searchKnowledge(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/knowledgebase/search`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取随访问卷列表tree
	 */
	static async getQuestionnaireDictListTree(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questionnaire/getQuestionnaireDictListTree`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 提交随访问卷记录（添加和修改）
	 */
	static async submitFollowupQuestionnaire(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questionnaire/submitFollowupQuestionnaire`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 保存满意度调查问卷记录（修改）
	 */
	static async submitSatisfactionQuestionnaire(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questionnaire/submitSatisfactionQuestionnaire`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}



	/**
	 * 绑定随访问卷（排期前）
	 */
	static async bindQuestionnaire(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questionnaire/bindQuestionnaire`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 首次登录修改密码
	 */
	static async changeDefaultPwd(opt){
		let res = await axios({
			url: `${baseUrl}/user/changeDefaultPwd`,
			method: 'post',
			data: qs.stringify(opt)
		});
		return result(res);
	}


	/**
	 * 获取排期模板列表
	 */
	static async getScheduleTemplateList() {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/listTemplScheduleTree`,
			method: 'post',
			headers : {'token': user.token}
		});
		return result(res);
	}

	/**
	 * 根据模板id查询 排期模板内容列表（计算日期）~~ 生成排期 月30天 年365天
	 */
	static async getScheduleTemplateInfo(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/listTemplScheduleInfoList`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 查询角色列表（系统管理）
	 */
	static async getRoleList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/role/getRoleList`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 查询单条角色
	 */
	static async getRole(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/role/getOneRole`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify({roleId: id})
		});
		return result(res);
	}

	/**
	 * 添加单条角色
	 */
	static async addRole(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/role/insertRole`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 修改单条角色
	 */
	static async editRole(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/role/updateRole`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 删除角色
	 */
	static async delRole(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/role/delete`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify({roleId: id})
		});
		return result(res);
	}

	/**
	 * 修改角色菜单权限
	 */
	static async updateRoleMenu(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/role/updateRoleMenu`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}


	/**
	 * 用户列表（系统管理）分页
	 */
	static async getUserList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/user/getUserList`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取单条用户（不含密码）
	 */
	static async getUser(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/user/getOneUser`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify({ userId: id })
		});
		return result(res);
	}

	/**
	 * 添加单条用户
	 */
	static async addUser(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/user/insertUser`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 修改单条用户
	 */
	static async editUser(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/user/updateUser`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 修改用户密码
	 */
	static async editUserPassword(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/user/updateUserPwd`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 用户管理 - 删除
	 */
	static async delUser(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/user/delete`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 用户管理 - 导入
	 */
	static async importUser(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/user/excel/import`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'multipart/form-data'},
			data: opt
		});
		return result(res);
	}
	// 新导入
	static async userExcelInsert(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/user/excel/excelInsert`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'multipart/form-data'},
			data: opt
		});
		return result(res);
	}
	/**
	 * 机构-查询所有数据
	 */
	static async getSysOrgAll(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysOrg/list/all`,
			method: 'get',
			headers : {'token': user.token},
			params: opt,
		});
		return result(res);
	}

	/**
	 * 机构-分页查询
	 */
	static async getSysOrgList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysOrg/list`,
			method: 'get',
			headers : {'token': user.token},
			// data: qs.stringify(opt),
			params: opt,
		});
		return result(res);
	}

	/**
	 * 机构 - 单条数据
	 */
	static async getSysOrg(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysOrg/${id}`,
			method: 'get',
			headers : {'token': user.token},
			params: {id},
		});
		return result(res);
	}

	/**
	 * 机构-查询机构下的科室数据
	 */
	static async getDeptListBySysOrgId(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysOrg/dept`,
			method: 'get',
			headers : {'token': user.token},
			params: {id},
		});
		return result(res);
	}

	/**
	 * 机构-新增
	 */
	static async addSysOrg(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysOrg/add`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 机构-更新
	 */
	static async editSysOrg(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysOrg/update`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 机构-删除
	 */
	static async delSysOrg(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysOrg/del/${id}`,
			method: 'post',
			headers : {'token': user.token},
		});
		return result(res);
	}
	// 机构下拉框
	static async getListComboboxOrg(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysOrg/listComboboxOrg`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	/**
	 * 规则管理 - 查询
	 */
	static async getSysRule() {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysRule/getSysRule`,
			method: 'get',
			headers : {'token': user.token},
		});
		return result(res);
	}

	/**
	 * 规则管理 - 保存
	 */
	static async saveSysRule(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/sysRule/saveSysRule`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 菜单管理 - 列表
	 */
	static async getMenuList() {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/menu/all`,
			method: 'get',
			headers : {'token': user.token},
		});
		return result(res);
	}

	/**
	 * 菜单管理 - 树结构
	 */
	static async getMenuTree() {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/menu/all/tree`,
			method: 'get',
			headers : {'token': user.token},
		});
		return result(res);
	}

	/**
	 * 菜单管理 - 单条菜单
	 */
	static async getMenu(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/menu/getOneMenu`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify({menuId: id})
		});
		return result(res);
	}

	/**
	 * 菜单管理 - 当前用户菜单
	 */
	static async getMyMenu() {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/menu/user`,
			method: 'post',
			headers : {'token': user.token},
		});
		return result(res);
	}

	/**
	 * 菜单管理 - 添加
	 */
	static async addMenu(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/menu/insertMenu`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 菜单管理 - 修改
	 */
	static async editMenu(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/menu/updateMenu`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 菜单管理 - 删除
	 */
	static async delMenu(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/menu/delete/${id}`,
			method: 'get',
			headers : {'token': user.token},
			params: { id },
		});
		return result(res);
	}

	/**
	 * 发送短信
	 */
	static async sendSMS(opt) {
		let user = getUser();
		let res = {}
		switch(hospitalCode){
			// case 'YS_HM4':
			// 	console.log('演示发短信');
			// 	return {code:1000};
			default :
				try{
					res = await axios({
						url: `${baseUrl}/message/sendCommunicationSms`,
						method: 'post',
						headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
						data: opt
					});
					return result(res);
				}catch(e){
					console.log(e);
					return "短信功能未开通";
				}
		}
	}
	/**
	 * 打电话
	 */
	static async makePhoneCall(mobile) {
		let user = getUser();
		let res = {}
		switch(hospitalCode){
			case 'AH_FY1' :
				console.log('阜阳打电话：'+mobile)
				try{
					res = await axios({
						url: `http://localhost:50668/PostCallTel/${mobile}`,
						method: 'get'
					});
					return res ? true : false;
				}catch(e){
					return false;
				}
			case 'FJ_SM1':
				return  "copyMobile";
		
			default:
				return hospitalCode;
		}
	}
	/*
		冠讯拨打时调接口
	*/
	static async addCallRecordGX(opt) {//废弃 已合并ubox
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/call/addCallRecordGX`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}

	/**
	 * 冠讯同步呼叫记录
	 */
	static async getSynchronization(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/call/syncCallRecordGX`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}
	/*
		1呼入电话信息列表并新建呼入记录
	*/
	static async getCallPhoneList(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/call/phoneList`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}
	// 2呼出时新建记录（盒子）无文件
	static async addCallRecord(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/call/addRecord`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}
	// 3更新记录（盒子）盒子server调用 存文件
	static async updateCallRecord(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/call/updateRecord`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}
	// 4更新记录-患者信息（盒子
	static async updatePatientRecord(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/call/updatePatientRecord`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}
	/**
	 * 删除患者亲属
	 * @param {integer} patientRelativeId 患者亲属id
	 */
	static async delRelative(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/delPatientRelative`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}

	/**
	 * 添加单条排期模板
	 * @param {integer} departmentId 科室id（注意0代表通用）
	 * @param {string} name 模板名称
	 */
	static async addScheduleTemplate(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/insertTemplSchedule`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}

	/**
	 * 添加单条排期模板内容
	 * @param {integer} dateNum  间隔数
	 * @param {string} dateUnit  间隔单位：1日、2周、3月、4年
	 * @param {string} templateContent  排期模板内容
	 * @param {integer} templateScheduleId  排期模板id
	 *
	 */
	static async addScheduleTemplateInfo(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/insertTemplScheduleInfo`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}
	/**
	 * 修改单条排期模板
	 * @param {integer} departmentId 科室id
	 * @param {integer} id 模板id
	 * @param {string} name 模板名称
	 */
	static async updateScheduleTemplate(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/updateTemplSchedule`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}

	/**
	 * 修改单条排期模板内容
	 * @param {integer} dateNum  间隔数
	 * @param {string} dateUnit  间隔单位：1日、2周、3月、4年
	 * @param {string} templateContent  排期模板内容
	 * @param {integer} templateScheduleId  排期模板id
	 * @param {integer} id 排期详情id
	 */
	static async updateScheduleTemplateInfo(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/updateTemplScheduleInfo`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}

	/**
	 * 获取排期模板列表
	 * @param {integer} departmentId 科室id（注意0代表通用）
	 * @param {string} name 模板名称
	 * @param {integer} pageNumber 当前页码
	 * @param {integer} pageSize 每页显示条数
	 *
	 */
	static async getScheduleTemplate(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/listTemplScheduleTreeDetail`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}
	/**
	 * 获取排期模板内容列表
	 * @param {integer} pageNumber 当前页码
	 * @param {integer} pageSize 每页显示条数
	 * @param {integer} templateId 模板id
	 */
	static async getScheduleTemplateInfoById(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/listTemplScheduleInfoDetail`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}
	/**
	 * 删除排期模板
	 * @param {array} ids	模板ids
	 */
	static async delScheduleTemplate(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/delTemplSchedule`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}
	/**
	 * 删除排期内容
	 * @param {array} ids	模板内容ids
	 */
	static async delScheduleTemplateInfo(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/delTemplScheduleInfo`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}
	// 复制模板

	static async copyTemplate(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/template/copyTemplte`,
			method: 'post',
			headers : {'token': user.token},
			data:qs.stringify(opt)
		});

		return result(res);
	}
	/**
	 * 获取患者血脂列表
	 * @param {integer} dataType	数据源(1住院、2门诊、3随访、4体检、5自测、6急诊)
	 * @param {string} measuringTimeStart	测量时间开始
	 * @param {string} measuringTimeEnd	测量时间结束
	 * @param {integer} patientId	患者id
	 * @param {integer} pageNumber	当前页码
	 * @param {integer} pageSize	每页显示条数
	 */
	static async getPatientBloodFat(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/listPatientBloodFat`,
			method : 'post',
			headers : {'token': user.token},
			data : qs.stringify(opt)
		});

		return result(res);
	}

	/**
	 * 新增患者血脂
	 * @param {integer} chol  总胆固醇
	 * @param {integer} hdl  高密度脂蛋白胆固醇
	 * @param {integer} ldl  低密度脂蛋白胆固醇
	 * @param {string} tg  甘油三酯
	 * @param {integer} measuringTime  检查时间
	 * @param {integer} patientId	患者id
	 */
	static async addPatientBloodFat(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/add/bloodFat`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	//删除血脂
	static async delPatientLabBloodFat(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/bloodFat/delete`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 更新血脂
	static async updatePatientLabBloodFat(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/update/bloodFat`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 获取患者血压列表
	 * @param {integer} dataType	数据源(1住院、2门诊、3随访、4体检、5自测、6急诊)
	 * @param {string} measuringTimeStart	测量时间开始
	 * @param {string} measuringTimeEnd	测量时间结束
	 * @param {integer} patientId	患者id
	 * @param {integer} pageNumber	当前页码
	 * @param {integer} pageSize	每页显示条数
	 */
	static async getPatientBloodPressure(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/listPatientBloodPressure`,
			method : 'post',
			headers : {'token': user.token},
			data : qs.stringify(opt)
		});

		return result(res);
	}

	/**
	 * 新增患者血压
	 * @param {integer} dbp  舒张压
	 * @param {integer} sbp  收缩压
	 * @param {string} vitalSignsId  生命体征测量记录流水号
	 * @param {integer} measuringTime  检查时间
	 * @param {integer} patientId	患者id
	 */
	static async addPatientBloodPressure(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/add/bloodPressure`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	//删除血压
	static async delPatientLabBloodPressure(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/bloodPressure/delete`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 更新血压
	static async updatePatientLabBloodPressure(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/update/bloodPressure`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	/**
	 * 获取患者血糖列表
	 * @param {integer} dataType	数据源(1住院、2门诊、3随访、4体检、5自测、6急诊)
	 * @param {string} measuringTimeStart	测量时间开始
	 * @param {string} measuringTimeEnd	测量时间结束
	 * @param {integer} patientId	患者id
	 * @param {integer} pageNumber	当前页码
	 * @param {integer} pageSize	每页显示条数
	 */
	static async getPatientBloodSugar(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/listPatientBloodSugar`,
			method : 'post',
			headers : {'token': user.token},
			data : qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 新增患者血糖
	 * @param {integer} glu  葡萄糖
	 * @param {integer} hba1c 糖化血红蛋白
	 * @param {integer} type  类型（1随机2空腹3早餐后2小时4午餐前5午餐后2小时6晚餐前7晚餐后2小时8睡前）
	 * @param {integer} measuringTime  检查时间
	 * @param {integer} patientId	患者id
	 */
	static async addPatientBloodSugar(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/add/bloodSugar`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	//删除血糖
	static async delPatientLabBloodSugar(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/bloodSugar/delete`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 更新血糖
	static async updatePatientLabBloodSugar(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/update/bloodSugar`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	/**
	 * 获取患者血尿酸列表
	 * @param {integer} dataType	数据源(1住院、2门诊、3随访、4体检、5自测、6急诊)
	 * @param {string} startTime	测量时间开始
	 * @param {string} endTime	测量时间结束
	 * @param {integer} patientId	患者id
	 * @param {integer} pageNumber	当前页码
	 * @param {integer} pageSize	每页显示条数
	 */
	static async getPatientUA(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/list/ua`,
			method : 'get',
			headers : {'token': user.token},
			params : opt
		});
		return result(res);
	}

	/**
	 * 新增患者血尿酸
	 * @param {integer} ua  血尿酸
	 * @param {integer} measuringTime  检查时间
	 * @param {integer} patientId	患者id
	 */
	static async addPatientUA(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/add/ua`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	//删除血尿酸
	static async delPatientLabBloodUa(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/ua/delete`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 更新血尿酸
	static async updatePatientLabBloodUa(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/update/ua`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 获取体征数据源列表
	 */
	static async getPatientBioSourceType(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/getPatientBioSourceType`,
			method : 'post',
			headers : {'token': user.token},
			data : qs.stringify(opt)
		});

		return result(res);
	}

	/**
	 * 获取血糖类型列表
	 */
	static async getPatientBloodSugarType(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/listPatientBloodSugarType`,
			method : 'post',
			headers : {'token': user.token},
			data : qs.stringify(opt)
		});

		return result(res);
	}

	/**
	 * 获取患者身高体重列表
	 * @param {integer} dataType	数据源(1住院、2门诊、3随访、4体检、5自测、6急诊)
	 * @param {string} startTime	测量时间开始
	 * @param {string} endTime	测量时间结束
	 * @param {integer} height	身高cm
	 * @param {integer} weight	体重
	 * @param {integer} bmi	BMI（体重/身高^2）
	 * @param {integer} patientId	患者id
	 * @param {integer} pageNumber	当前页码
	 * @param {integer} pageSize	每页显示条数
	 */
	static async getPatientLabBasic(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/list/basic`,
			method : 'get',
			headers : {'token': user.token},
			params : opt
		});
		return result(res);
	}

	/**
	 * 患者检验 - 新增患者基身高体重
	 * @param {integer} height	身高cm
	 * @param {integer} weight	体重
	 * @param {integer} bmi	BMI（体重/身高^2）
	 * @param {integer} measuringTime  检查时间
	 * @param {integer} patientId	患者id
	 */
	static async addPatientLabBasic(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/add/basic`,
			method : 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data : opt
		});

		return result(res);
	}
		//删除基本身高数据
		static async delPatientLabBasic(opt) {
			let user = getUser();
			let res = await axios({
				url: `${baseUrl}/patient/lab/basic/delete`,
				method: 'post',
				headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
				data: opt
			});
			return result(res);
		}
		// 更新基本身高数据
		static async updatePatientLabBasic(opt){
			let user = getUser();
			let res = await axios({
				url: `${baseUrl}/patient/lab/update/basic`,
				method: 'post',
				headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
				data: opt
			});
			return result(res);
		}

	/**
	 * 新增糖化血红蛋白
	 * @param {integer} itemResult  糖化血红蛋白结果
	 * @param {string} dataType  类型
	 * @param {integer} lisDate  检查时间
	 * @param {integer} patientId	患者id
	 */
	static async addPatientLabHba1c(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/add/hba1c`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	//查询糖化血红蛋白列表
	static async getPatientLabHba1c(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/list/hba1c`,
			method : 'get',
			headers : {'token': user.token},
			params : opt
		});
		return result(res);
	}
	/**
	 * 删除患者糖化血红蛋白
	 */
	static async delPatientLabLis(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/delete/lis`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 更新糖化血红蛋白
	static async updatePatientLabHba1c(opt){
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/update/hba1c`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	/**
	 * 患者检验 - 添加丙肝病毒
	 * @param {integer} dataType	类型(0院中Pad、1化验检验、3后台录入、4患者自测)
	 * @param {integer} itemResult	检验报告详细项目结果
	 * @param {integer} recordId	就诊记录唯一ID
	 * @param {integer} patientId	患者id
	 */
		static async addPatientHcvRna(opt){
			let user = getUser();
			let res = await axios({
				url : `${baseUrl}/patient/lab/add/hcvRna`,
				method : 'post',
				headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
				data : opt
			});

			return result(res);
	}

	/**
	 * 查询丙肝病毒列表
	 */
	static async getPatienthcvRnaList(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/list/hcvRna`,
			method : 'get',
			headers : {'token': user.token},
			params : opt
		});
		return result(res);
	}
	/**
	 * 查询丙肝抗体列表
	 */
	static async getPatientHcvList(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/list/hcv`,
			method : 'get',
			headers : {'token': user.token},
			params : opt
		});
		return result(res);
	}
	// 删除检验数据
	static async delLabLisPatient(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/lis/delete`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 获取甲胎蛋白
	static async getListPatientAFP(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/listPatientAFP`,
			method : 'post',
			headers : {'token': user.token},
			data : qs.stringify(opt)
		});
		return result(res);
	}
	// 新增甲胎蛋白
	static async addPatientAFP(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/add/afp`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 更新甲胎蛋白
	static async updatePatientAFP(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/update/afp`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 获取患者谷丙转氨酶列表
	static async getListPatientALT(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/listPatientALT`,
			method : 'post',
			headers : {'token': user.token},
			data : qs.stringify(opt)
		});
		return result(res);
	}
	// 新增患者谷丙转氨酶列表
	static async addListPatientALT(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/add/alt`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 更新患者谷丙转氨酶列表
	static async updateListPatientALT(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/update/alt`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 获取患者谷草转氨酶列表
	static async getListPatientAST(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/listPatientAST`,
			method : 'post',
			headers : {'token': user.token},
			data : qs.stringify(opt)
		});
		return result(res);
	}
	// 新增患者谷草转氨酶列表
	static async addListPatientAST(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/add/ast`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 更新患者谷草转氨酶列表
	static async updateListPatientAST(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/update/ast`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	// 获取患者丙肝RNA测定
	static async getListPatientBGDNA(opt){
		let user = getUser();
		let res = await axios({
			url : `${baseUrl}/patient/lab/listPatientBGDNA`,
			method : 'post',
			headers : {'token': user.token},
			data : qs.stringify(opt)
		});
		return result(res);
	}
	// 新增患者丙肝RNA测定
	static async addListPatientBGDNA(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/add/bgdna`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 更新患者丙肝RNA测定
	static async updateListPatientBGDNA(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/update/bgdna`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}


	// 获取患者乙肝DNA测定
	static async getListPatientHbvDNA(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/listPatientHbvDNA`,
			method: 'post',
			headers : {'token': user.token},
			data : qs.stringify(opt)
		});
		return result(res);
	}
	// 新增患者乙肝DNA测定
	static async addListPatientHbvDNA(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/add/hbvDna`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 更新患者乙肝DNA测定
	static async updateListPatientHbvDNA(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/patient/lab/update/hbvDna`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// // 乙肝统计
	static async getHepatitisBReport(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/lis/getHepatitisBReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	// 丙肝统计
	static async getHepatitisCReport(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/lis/getHepatitisCReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 获取验证码图片
	 */
	static async getCaptcha(opt){
		let res = await axios.post(`${baseUrl}/captcha`, qs.stringify(opt));
		return result(res);
	}

	/**
	 * 出院复诊统计
	 * @param {string} recordTimeStart 开始时间
	 * @param {string} recordTimeEnd 结束时间
	 * @param {integer} depId 科室id
	 */
	static async getOutHospitalReturnVisitReport(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/outHospitalReturnVisit/listReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	// 复诊统计
	static async getReturnVisitReport(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/returnVisit/listFollowupReturnVisitReport`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 院中沟通记录
	 */
	static async communicationDialogueList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/communicationDialogue/list`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 未读数量
	 */
	static async unreadmsg(userId) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/communicationDialogue/unreadmsg/${userId}`,
			method: 'get',
			headers : {'token': user.token}
		});
		return result(res);
	}

	/**
	 * 已读
	 */
	static async read() {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/communicationDialogue/read`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'}
		});
		return result(res);
	}
	/**
	 * 用户通知 - 分页查询当前用户未读聊天
	 */
	static async getUserNoticeList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/communicationDialogue/unreadmsg/list`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 用户通知 - 设置消息为已读
	 */
	static async updateUserNotice(msgIds) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/communicationDialogue/read`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: { msgIds }
		});
		return result(res);
	}

	/**
	 * 用户消息 - 分页查询当前用户的未读消息
	 */
	static async getUserMessageList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/message/unread`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 用户消息 - 修改消息查看状态为已读
	 */
	static async updateUserMessage(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/message/updateMessageByMessageId`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: { id }
		});
		return result(res);
	}
	/**
	 * 获取院中管理信息
	 */
	static async getInhospitalInfo(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/inhospital/info/${id}`,
			method: 'get',
			headers : {'token': user.token}
		});
		return result(res);
	}

	/**
	 * 新增问卷
	 */
	static async questionresultAdd(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questionresult/add`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 保存问卷
	 */
	static async saveQuestionnaireResult(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/customerEval/add/questionnaireResult`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}

	/**
	 * 删除问卷
	 */
	static async delQuestionnaireResult(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questionresult/del/${id}`,
			method: 'post',
			headers : {'token': user.token}
		});
		return result(res);
	}

	/**
	 * 问卷字典分页查询
	 */
	static async getQuestiondictList(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questiondict/list`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 问卷字典单个信息
	 */
	static async getQuestiondictById(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questiondict/${id}`,
			method: 'get',
			headers : {'token': user.token}
		});
		return result(res);
	}
	/**
	 * 新增问卷字典
	 */
	static async addQuestiondict(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questiondict/add`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}
	/**
	 * 更新问卷字典
	 */
	static async updateQuestiondictById(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questiondict/update`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}

	/**
	 * 删除问卷字典
	 */
	static async delQuestiondictById(id) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questiondict/del/${id}`,
			method: 'post',
			headers : {'token': user.token}
		});
		return result(res);
	}


	/**
	 * 根据类型查询问卷字典信息
	 */
	static async getQuestiondictByType(type) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/questiondict/type/${type}`,
			method: 'get',
			headers : {'token': user.token}
		});
		return result(res);
	}

	/**
	 * 获取问卷统计详情
	 */
	static async getQuestionnaireDetail(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/questiondictReport/getQuestionnaireDetail`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}


	/**
	 * 获取问卷统计汇总
	 */
	static async getQuestionnaireGather(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/report/questiondictReport/getQuestionnaireGather`,
			method: 'post',
			headers : {'token': user.token},
			data: qs.stringify(opt)
		});
		return result(res);
	}


	/**
	 * 新增院中沟通记录
	 */
	static async addCommunicationDialogue(opt) {
		let user = getUser();
		let res = await axios({
			url: `${baseUrl}/communicationDialogue/add`,
			method: 'post',
			headers : {'token': user.token, 'Content-Type': 'application/json;charset=UTF-8'},
			data: opt
		});
		return result(res);
	}
	// 下载用户模板xlsx
	static downloadUserExcel(opt) {
		let user = getUser();
		let obj = {...opt};
		return `${baseUrl}/user/excel/tpl?${qs.stringify(obj)}&token=${user.token}`;
	}
	// 下载错误用户
	static downloadUserErrorList(opt) {
		let user = getUser();
		let obj = {...opt};
		return `${baseUrl}/user/excel/errorList?${qs.stringify(obj)}&token=${user.token}`;
	}

	/****** 导出报表 ******/
	static exportStatisticsSchedule(opt) {
		let user = getUser();
		return `${baseUrl}/report/outHospitalWorkload/listReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}

	static exportStatisticsDepartment(opt) {
		let user = getUser();
		return `${baseUrl}/report/outHospitalWorkload/listDocReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}

	static exportStatisticsFollow(opt) {
		let user = getUser();
		return `${baseUrl}/report/outHospitalfollowup/listReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}

	static exportStatisticsManage(opt) {
		let user = getUser();
		return `${baseUrl}/report/outHospitalfollowup/listDiseaseManagerReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}

	static exportStatisticsSchedule2(opt) {
		let user = getUser();
		return `${baseUrl}/report/outPatientWorkload/listReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}

	static exportStatisticsDepartment2(opt) {
		let user = getUser();
		return `${baseUrl}/report/outPatientWorkload/listDocReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}

	static exportStatisticsFollow2(opt) {
		let user = getUser();
		return `${baseUrl}/report/outPatientfollowup/listReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}

	static exportStatisticsManage2(opt) {
		let user = getUser();
		return `${baseUrl}/report/outPatientfollowup/listDiseaseManagerReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}
	static exportStatisticsReturn(opt) {
		let user = getUser();
		return `${baseUrl}/report/outHospitalReturnVisit/listReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}
	static exportOuthospitalReport(opt) {
		let user = getUser();
		return `${baseUrl}/outhospital2Report/listOuthospitalReport?${qs.stringify(opt)}&token=${user.token}`;
	}
	static exportFollowup2ByObject(opt) {
		let user = getUser();
		return `${baseUrl}/followup2report/listFollowup2ByObject?${qs.stringify(opt)}&token=${user.token}`;
	}

	static exportAppointmentReturnVisit2ByObject(opt) {
		let user = getUser();
		return `${baseUrl}/followup2report/listAppointmentReturnVisit2ByObject?${qs.stringify(opt)}&token=${user.token}`;
	}
	static exportStatisticEvaluatorsReport(opt) {
		let user = getUser();
		return `${baseUrl}/report/inHospital/listEvaluatorsReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}
	static exportStatisticManagerReport(opt) {
		let user = getUser();
		return `${baseUrl}/report/inHospital/listInHospitalManagerReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}
	static exportStatisticPrescriptionReport(opt) {
		let user = getUser();
		return `${baseUrl}/report/inHospital/listPrescriptionReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}
	static exportStatisticReturnVisitReport(opt) {
		let user = getUser();
		return `${baseUrl}/report/returnVisit/listFollowupReturnVisitReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}
	
	static exportlListHealthQuotient(opt) {
		let user = getUser();
		return `${baseUrl}/report/eval/listHealthQuotientReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}
	static exportlListBReportExport(opt) {
		let user = getUser();
		return `${baseUrl}/report/lis/getHepatitisBReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}
	static exportlListCReportExport(opt) {
		let user = getUser();
		return `${baseUrl}/report/lis/getHepatitisCReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}
	static exportListInHospitalReport(opt) {
		let user = getUser();
		return `${baseUrl}/inhospital/listInHospitalReport?${qs.stringify(opt)}&token=${user.token}`;
	}
	static exportListPatientByGrouping(opt) {
		let user = getUser();
		return `${baseUrl}/patient/listPatientByGroupingExport?${qs.stringify(opt)}&token=${user.token}`;
	}
	// 复诊工作量导出
	static exportListReturnVisitReport(opt) {
		let user = getUser();
		return `${baseUrl}/report/returnVisit/listFollowupReturnVisitDoctorReportExport?${qs.stringify(opt)}&token=${user.token}`;
	}
}


